import React from 'react';
import { InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';

const FilterInput = ({ className, onChange, placeholder, value }) => (
  <InputGroup className={className}>
    <InputGroupAddon addonType="prepend">
      <InputGroupText>Filter</InputGroupText>
    </InputGroupAddon>
    <Input onChange={onChange} value={value} placeholder={placeholder} />
  </InputGroup>
);

export default FilterInput;



// WEBPACK FOOTER //
// ./src/components/filterInput/filterInput.jsx